import React, { useState } from "react";
import "../assets/css/AddFollowup.css";
import axiosInstance from "../components/api/axiosInstance";

function AddFollowup({ id, type = "lead", onBack }) {
  const [formData, setFormData] = useState({
    followupDate: "",
    followupType: "",
    nextFollowupDate: "",
    remarks: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.followupDate) {
      alert("Followup Date is required.");
      return;
    }

    // Get logged-in user id from localStorage
    let createdBy = 1;
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        createdBy = user.user_id || user.id || 1;
      }
    } catch (error) {
      console.error("Error reading user data:", error);
    }

    setSubmitting(true);
    try {
      // Format dates to ISO string format (YYYY-MM-DDTHH:mm:ss)
      const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return null;
        // datetime-local input returns format: YYYY-MM-DDTHH:mm
        // API expects: YYYY-MM-DDTHH:mm:ss (most cases),
        // but internship followups sample expects: YYYY-MM-DD HH:mm:ss (space).
        const withSeconds = dateTimeString + ":00";
        if (type === "internship-lead" || type === "realestate-lead") {
          return withSeconds.replace("T", " ");
        }
        return withSeconds;
      };

      const payload = {
        Followup_Date: formatDateTime(formData.followupDate),
        Remarks: formData.remarks || null,
        Next_Followup_Date: formatDateTime(formData.nextFollowupDate),
        Created_By: createdBy,
      };

      // Include Followup_Type for all types that support it
      payload.Followup_Type = formData.followupType || null;

      if (type === "lead") payload.Lead_Id = id;
      if (type === "client") payload.client_id = id;
      if (type === "training-lead") payload.Training_Lead_Id = id;
      if (type === "job-lead") payload.Job_Lead_Id = id;
      if (type === "internship-lead") payload.Internship_Lead_Id = id;
      if (type === "realestate-lead") payload.Real_Estate_Lead_Id = id;

      // Use type-specific followup endpoints
      const endpoint =
        type === "training-lead"
          ? "/create-training-followup"
          : type === "job-lead"
            ? "/create-job-followup"
            : type === "internship-lead"
              ? "/create-internship-followup"
              : type === "realestate-lead"
                ? "/create-real-estate-followup"
                : "/create-followup";
      await axiosInstance.post(endpoint, payload);
      alert("Followup added successfully!");
      onBack();
    } catch (error) {
      console.error("Error adding followup:", error);
      const errorMsg = error.response?.data?.message || error.response?.data?.error || "Failed to add followup. Please try again.";
      alert(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    onBack();
  };

  return (
    <div className="addfollowup-container">
      <form className="addfollowup-form" onSubmit={handleSubmit}>
        <div className="addfollowup-form-grid">
          {/* Followup Date */}
          <div className="addfollowup-form-group">
            <label>
              Followup Date <span className="required">*</span>
            </label>
            <input
              type="datetime-local"
              name="followupDate"
              value={formData.followupDate}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* Followup Type - show for all lead types (same as real estate) */}
          <div className="addfollowup-form-group">
            <label>Followup Type</label>
            <input
              type="text"
              name="followupType"
              value={formData.followupType}
              onChange={handleInputChange}
          
            />
          </div>

          {/* Next Followup Date */}
          <div className="addfollowup-form-group">
            <label>Next Followup Date</label>
            <input
              type="datetime-local"
              name="nextFollowupDate"
              value={formData.nextFollowupDate}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* Remarks */}
        <div className="addfollowup-remarks-group">
          <label>Remarks</label>
          <textarea
            name="remarks"
            value={formData.remarks}
            onChange={handleInputChange}
            rows={5}
            
          />
        </div>

        {/* Buttons */}
        <div className="addfollowup-actions">
          <button
            type="submit"
            className="btn-addfollowup-submit"
            disabled={submitting}
          >
            {submitting ? "Adding..." : "New Followup"}
          </button>
          <button
            type="button"
            className="btn-addfollowup-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddFollowup;
